/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],
  fromDateValue: '',
  toDateValue: '',
  rebateProgramName: '',
  adjustmentSelected: [],
  isLoading: false,
  claimAuditSelected: 'Both',
  claimCategorySelected: '',
  searchResult: [],
  referenceData: [],
  // claimAuditToggle: '',
  claimAuditReducer: '',
  searchScreenVar: {
    rebateProgramName: '',
    rebateProgramValue: '',
    selectedPlanType: '',
    fromDateValue: '',
    toDateValue: '',
    claimAuditSelected: 'Both',
    claimCategorySelected: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case ActionTypes.GET_REBATE_PROGRAM_UNALLOACTED_BALANCE:
      return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_INSTITUTIONAL_CLAIMS_DISCREPANCY:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_INSTITUTIONAL_CLAIMS_DISCREPANCY:
      return { ...state, isLoading: action.isLoading };
    //For All Adjustment Grid
    case ActionTypes.GET_INSTITUTIONAL_CLAIMS_DISCREPANCY_SEARCH_RESULT:
      return { ...state, searchResult: action.searchResult };
    case ActionTypes.REFRESH_INSTITUTIONAL_UNIT_TYPE_DISCREPANCY:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    //For All Reference Data
    case ActionTypes.GET_REFERENCE_DATA_INSTITUTIONAL_CLAIMS:
      return { ...state, referenceData: action.referenceData };

    default:
      return state;
  }
};

export default reducer;
